// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `wm-image-picker .wm-image-picker-advice {
  font-size: var(--wm-font-sm);
  color: var(--wm-color-medium);
}
wm-image-picker .wm-image-picker-loadphoto {
  padding: 16px;
  border-radius: 15px;
  border: 2px var(--ion-color-light-shade, var(--wm-color-light-shade)) dashed;
  text-align: center;
  width: 100%;
  height: 108px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
wm-image-picker .wm-image-picker-loadphoto.wm-image-picker-addimagecontainer {
  padding: 16px 10px;
}
wm-image-picker .wm-image-picker-loadphoto .wm-image-picker-loadphoto-text {
  font-size: var(--wm-font-sm);
}
wm-image-picker .wm-image-picker-loadphoto .wm-image-picker-loadphoto-text .wm-image-picker-loadphoto-action {
  display: inline;
  color: var(--wm-color-primary);
  font-weight: var(--wm-font-weight-bold);
}
wm-image-picker .wm-image-picker-loadphoto .wm-image-picker-loadphoto-icon {
  font-size: 28px;
  color: var(--wm-color-dark);
}
wm-image-picker .wm-image-picker-loadphoto .wm-image-picker-loadphoto-advice {
  font-size: var(--wm-font-xsm);
}
wm-image-picker .wm-image-picker-imagecontainer {
  text-align: center;
  height: 100px;
  width: 108px;
  position: relative;
  border-radius: 15px;
  overflow: hidden;
}
wm-image-picker .wm-image-picker-imagecontainer.wm-image-picker-addimagecontainer {
  border: dashed var(--wm-color-grey, var(--wm-color-light-shade)) 2px;
}
wm-image-picker .wm-image-picker-imagecontainer .wm-image-picker-image {
  height: 100px;
  width: 108px;
}
wm-image-picker .wm-image-picker-imagecontainer .wm-image-picker-image::part(image) {
  object-fit: cover;
}
wm-image-picker .wm-image-picker-imagecontainer .wm-image-picker-remove {
  position: absolute;
  top: 5px;
  right: 5px;
  height: 19px;
  width: 19px;
  border-radius: 10px;
  background: #ffffff;
  z-index: 1;
}
wm-image-picker .wm-image-picker-imagecontainer wm-ugc-synchronized-badge {
  display: flex;
  position: absolute;
  bottom: 5px;
  right: 5px;
  background: white;
  padding: 2px;
  border-radius: 50%;
  z-index: 1;
}
wm-image-picker .wm-image-picker-imagecontainer wm-ugc-synchronized-badge > ion-icon {
  width: 16px;
  height: 16px;
}
wm-image-picker .wm-image-picker-imagecontainer .wm-image-picker-add {
  font-size: 45px;
  color: var(--wm-color-dark);
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}`, "",{"version":3,"sources":["webpack://./src/app/shared/wm-core/projects/wm-core/src/image-picker/image-picker.component.scss"],"names":[],"mappings":"AACE;EACE,4BAAA;EACA,6BAAA;AAAJ;AAEE;EACE,aAAA;EAIA,mBAAA;EACA,4EAAA;EACA,kBAAA;EACA,WAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;AAHJ;AAPI;EACE,kBAAA;AASN;AAEI;EACE,4BAAA;AAAN;AAEM;EACE,eAAA;EACA,8BAAA;EACA,uCAAA;AAAR;AAII;EACE,eAAA;EACA,2BAAA;AAFN;AAKI;EACE,6BAAA;AAHN;AAOE;EACE,kBAAA;EACA,aAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;AALJ;AAOI;EACE,oEAAA;AALN;AAQI;EACE,aAAA;EACA,YAAA;AANN;AAOM;EACE,iBAAA;AALR;AASI;EACE,kBAAA;EACA,QAAA;EACA,UAAA;EAEA,YAAA;EACA,WAAA;EACA,mBAAA;EAEA,mBAAA;EACA,UAAA;AATN;AAYI;EACE,aAAA;EACA,kBAAA;EACA,WAAA;EACA,UAAA;EACA,iBAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;AAVN;AAWM;EACE,WAAA;EACA,YAAA;AATR;AAaI;EACE,eAAA;EACA,2BAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EAEA,gCAAA;AAXN","sourcesContent":["wm-image-picker {\n  .wm-image-picker-advice {\n    font-size: var(--wm-font-sm);\n    color: var(--wm-color-medium);\n  }\n  .wm-image-picker-loadphoto {\n    padding: 16px;\n    &.wm-image-picker-addimagecontainer {\n      padding: 16px 10px;\n    }\n    border-radius: 15px;\n    border: 2px var(--ion-color-light-shade, var(--wm-color-light-shade)) dashed;\n    text-align: center;\n    width: 100%;\n    height: 108px;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n\n    .wm-image-picker-loadphoto-text {\n      font-size: var(--wm-font-sm);\n\n      .wm-image-picker-loadphoto-action {\n        display: inline;\n        color: var(--wm-color-primary);\n        font-weight: var(--wm-font-weight-bold);\n      }\n    }\n\n    .wm-image-picker-loadphoto-icon {\n      font-size: 28px;\n      color: var(--wm-color-dark);\n    }\n\n    .wm-image-picker-loadphoto-advice {\n      font-size: var(--wm-font-xsm);\n    }\n  }\n\n  .wm-image-picker-imagecontainer {\n    text-align: center;\n    height: 100px;\n    width: 108px;\n    position: relative;\n    border-radius: 15px;\n    overflow: hidden;\n\n    &.wm-image-picker-addimagecontainer {\n      border: dashed var(--wm-color-grey, var(--wm-color-light-shade)) 2px;\n    }\n\n    .wm-image-picker-image {\n      height: 100px;\n      width: 108px;\n      &::part(image) {\n        object-fit: cover;\n      }\n    }\n\n    .wm-image-picker-remove {\n      position: absolute;\n      top: 5px;\n      right: 5px;\n\n      height: 19px;\n      width: 19px;\n      border-radius: 10px;\n\n      background: #ffffff;\n      z-index: 1;\n    }\n\n    wm-ugc-synchronized-badge {\n      display: flex;\n      position: absolute;\n      bottom: 5px;\n      right: 5px;\n      background: white;\n      padding: 2px;\n      border-radius: 50%;\n      z-index: 1;\n      > ion-icon {\n        width: 16px;\n        height: 16px;\n      }\n    }\n\n    .wm-image-picker-add {\n      font-size: 45px;\n      color: var(--wm-color-dark);\n      position: absolute;\n      top: 50%;\n      left: 50%;\n      -ms-transform: translate(-50%, -50%);\n      transform: translate(-50%, -50%);\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
